import { Component, OnInit, Input, EventEmitter, ViewChild, Output } from '@angular/core';
import { ModalDirective, ModalOptions } from 'angular-bootstrap-md';
import {ToastrService} from 'ngx-toastr';
import { FilesService } from '../../../services/files.service';

@Component({
  selector: 'add-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class AddFilesComponent implements OnInit {
  @Input('idTicket') idTicket: number;
  @Output('actualizar')actualizar = new EventEmitter<boolean>();
  @ViewChild('demoBasic') demoBasic: ModalDirective;
  @Input('state')state: string;
  disabled = false;
  modalConfigDefaults: ModalOptions = {
      backdrop: false,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      animated: true
    };
    visible = false;
  constructor(private toastr: ToastrService, private fileService: FilesService ) { }

  ngOnInit() {
    this.disabled = this.state == 'finalizados';
    this.demoBasic.config = this.modalConfigDefaults;
  }

  actualizarVista(id) {
    this.cerrarVentana();
    if(event) this.setAdjuntoPedido(id[0]);

  }

  setAdjuntoPedido(id){
    this.fileService.setAdjuntoPedido(this.idTicket, id).subscribe((ok:boolean) => {
      if(ok){
        this.toastr.success('Archivo grabado', 'Exito');
      }  else {
        this.toastr.error('No se vinculo el archivo al pedido deseado', 'Error');
      }
      this.actualizar.emit(ok);
    });
  }

cerrarVentana(){
  this.visible = false;
  this.demoBasic.hide();
}
abrirVentana(){
  this.visible = true;
  this.demoBasic.show();
}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modals/files/files.component.ts